'use es6';

import promiseClient from 'hub-http/adapters/promiseClient';
import { toolsHubSpotterStack } from '../stacks/hubSpotter';
export default promiseClient(toolsHubSpotterStack);